import { useQuery, useMutation } from "@tanstack/react-query";
import { queryClient } from "./queryClient";
import { getUserId } from "../utils";
import { apiClient } from "./apiClient";
import { useFundsStore } from "../store";

export function useFunds() {
  const { setFunds } = useFundsStore();
  const userId = getUserId();

  const funds = useQuery({
    queryKey: ["funds", userId],
    queryFn: async () => {
      if (!userId) throw new Error("User ID not available");

      const response = await apiClient.get(`/funds/getfunds?user_id=${userId}`);
      const funds = response.data.funds;

      // Update Zustand store with fetched data
      setFunds(funds);

      return funds;
    },
    enabled: !!userId, // Only run if userId exists
  });

  const transferFunds = useMutation({
    mutationFn: async ({ account, idNumber, amount }) => {
      const response = await apiClient.post("/funds/transfer", {
        account,
        idNumber,
        amount,
        user_id: userId,
      });
      return response;
    },
    onSuccess: () => {
      // Invalidate and refetch funds after successful transfer
      queryClient.invalidateQueries({ queryKey: ["funds", userId] });
    },
  });

  const withdrawFunds = useMutation({
    mutationFn: async ({ idNumber, amount }) => {
      const response = await apiClient.post("/funds/withdraw", {
        idNumber,
        amount,
        user_id: userId,
      });
      return response;
    },
    onSuccess: () => {
      // Invalidate and refetch funds after successful withdrawal
      queryClient.invalidateQueries({ queryKey: ["funds", userId] });
    },
  });

  return { funds, transferFunds, withdrawFunds };
}
